import { motion } from "framer-motion";
import { VALUES } from "@/lib/constants";

export default function Why() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="bg-[#F8F8F8] py-16 sm:py-28"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-3xl mb-12 sm:mb-20">
          <p className="overline mb-4 sm:mb-5 text-[10px] sm:text-xs">
            <span className="inline-block w-8 sm:w-10 h-px bg-[#D4AF37] align-middle mr-3 sm:mr-4" />
            Hvorfor vælge Gudiksen Stays
          </p>
          <h2
            className="font-serif text-[2.25rem] sm:text-5xl lg:text-6xl text-[#111111] font-light tracking-tight leading-[1.05]"
            style={{ fontFamily: "Fraunces, serif" }}
          >
            Hvorfor vælger boligejere{" "}
            <span className="italic text-[#C9A227]">Gudiksen Stays?</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 sm:gap-12 lg:gap-16">
          {VALUES.map((v, i) => (
            <motion.div
              key={v.n}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: "easeOut" }}
              className="relative"
              data-testid={`value-${v.n}`}
            >
              <div
                className="num-tag text-6xl sm:text-8xl mb-5 sm:mb-6"
                style={{ fontFamily: "Fraunces, serif" }}
              >
                {v.n}
              </div>
              <div className="h-px w-12 sm:w-16 bg-[#111111]/20 mb-5 sm:mb-6" />
              <h3
                className="font-serif text-xl sm:text-3xl text-[#111111] font-normal leading-tight mb-3 sm:mb-4"
                style={{ fontFamily: "Fraunces, serif" }}
              >
                {v.title}
              </h3>
              <p className="text-[#555555] font-light leading-relaxed">
                {v.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
